import { CheckedAddress } from '@/domain/types/CheckedAddress'
import {
  mainnet,
  berachain,
  ink,
  avalanche,
  arbitrum,
  base,
  worldchain,
  zksync,
  sonic,
  polygon,
  unichain,
  bsc,
  optimism,
  gnosis,
  linea,
} from 'viem/chains'

import { type Chain } from 'viem'
import { PrivyClientConfig } from '@privy-io/react-auth'
import { APP_ORIGIN } from '@/config/consts'

// @NOTE: these are accessed via index throughout the app
export const rpcUrls = [
  'https://hyperliquid-mainnet.g.alchemy.com/v2/i-LmQZEsBaAdH8OiEtU-N',
  'https://rpc.hyperliquid.xyz/evm',
]

export const hyperEVM = {
  id: 999,
  name: 'HyperEVM',
  nativeCurrency: { name: 'Hype', symbol: 'HYPE', decimals: 18 },
  rpcUrls: {
    default: {
      http: rpcUrls,
    },
  },
  blockExplorers: {
    default: { name: 'HyperEVMScan', url: 'https://www.hyperevmscan.io' },
  },
  contracts: {
    multicall3: {
      address: '0xcA11bde05977b3631167028862bE2a173976CA11',
    },
    repayHelper: {
      address: '0xcD25A8404f136E762c5c18285223815BC3407f24',
    },
  },
} as const satisfies Chain

export const SUPPORTED_CHAINS_DEFAULT = [hyperEVM]
export const SUPPORTED_CHAIN_IDS = SUPPORTED_CHAINS_DEFAULT.map((chain) => chain.id)

export const SUPPORTED_CHAINS = [
  hyperEVM,
  mainnet,
  base,
  arbitrum,
  optimism,
  polygon,
  linea,
  bsc,
  berachain,
  ink,
  avalanche,
  worldchain,
  zksync,
  sonic,
  unichain,
  gnosis,
]

export const SUPPORTED_CHAIN_ID_TO_LOGOS: Record<number, string> = {
  [hyperEVM.id]: 'hyperliquid',
  [mainnet.id]: 'ethereum',
  [base.id]: 'base',
  [arbitrum.id]: 'arbitrum',
  [optimism.id]: 'optimism',
  [polygon.id]: 'polygon',
  [linea.id]: 'linea',
  [bsc.id]: 'bsc',
  [berachain.id]: 'bera',
  [ink.id]: 'ink',
  [avalanche.id]: 'avalanche',
  [worldchain.id]: 'worldchain',
  [zksync.id]: 'zksync',
  [sonic.id]: 'sonic',
  [unichain.id]: 'unichain',
  [gnosis.id]: 'gnosis',
}

export const privyConfig: PrivyClientConfig = {
  defaultChain: hyperEVM,
  appearance: {
    showWalletLoginFirst: true,
    theme: '#0c0c0e',
    accentColor: '#a1fce7',
    logo: `${APP_ORIGIN}/hypurr-paw.svg`,
    walletList: [
      'detected_ethereum_wallets',
      'metamask',
      'phantom',
      'rabby_wallet',
      'wallet_connect',
      'wallet_connect_qr',
    ],
  },
}

export const isolatedRegistryAddress = {
  [hyperEVM.id]: CheckedAddress('0x5aB54F5Ca61ab60E81079c95280AF1Ee864EA3e7'),
} as const
